import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'

interface ChartCardProps {
  title: string
  chartId: string
  options: ApexOptions
  height?: number
  className?: string
}

const ChartCard: React.FC<ChartCardProps> = React.memo(({ title, chartId, options, height = 350, className = '' }) => {
  const chartRef = useRef<HTMLDivElement>(null)
  const chartInstance = useRef<ApexCharts | null>(null)

  useEffect(() => {
    if (!chartRef.current) return

    if (chartInstance.current) {
      chartInstance.current.destroy()
      chartInstance.current = null
    }

    const chart = new ApexCharts(chartRef.current, { ...options, chart: { ...options.chart, height } })
    chart.render()
    chartInstance.current = chart

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy()
        chartInstance.current = null
      }
    }
  }, [options, height])

  return (
    <div className={`card border-0 shadow-sm ${className}`}>
      <div className="card-header border-0 pt-6 pb-0">
        <h3 className="card-title fw-bold text-gray-900 fs-5">{title}</h3>
      </div>
      <div className="card-body pt-4">
        <div ref={chartRef} id={chartId}></div>
      </div>
    </div>
  )
})

export default ChartCard
